<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <template v-for="(row,index) in configForm.coupons[0].coupons">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="activityReward">
              <div class="d-flex">
                <el-select v-model="row.couponId" style="width: 200px;" placeholder="请选择优惠券">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType" @change="partakeCancelTree()">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择机构 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.mechanism"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleMechanismChange"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.tag"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleTagChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import { numberfilter } from '@/utils/tool'
const token = window.localStorage.getItem('token')
export default {
  data() {
    return {
      dataId: '',
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterMechanismText: '', // 机构过滤
      filterTagText: '', // 标签过滤
      // 活动信息表单
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: '' // 活动说明
      },
      // 活动信息表单校验
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动配置表单
      configForm: {
        coupons: [
          {
            coupons: [
              {
                couponId: '', // 优惠券类型
                count: ''// 优惠券数量
              }
            ]
          }
        ]
      },
      // 活动配置表单校验
      configRules: {
        activityReward: { required: true, trigger: 'change',
          validator: (rewardRules, value, cb) => {
            if (this.couponRule) {
              return cb(new Error(this.couponRule))
            }
            return cb()
          }
        }
      },
      // 可参与用户字段的单选数据
      userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        }, {
          label: '选择机构',
          id: '2'
        }, {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 机构树的全部数据
      tagTreeData: [], // 标签树的全部数据
      // 可参与用户表单
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择机构
        tag: []// 选择标签
      },
      partakeRules: {
        userType: [
          { required: true, message: '请选择可参与用户', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: token
      }
    },
    action() {
      return HOST + '/oss'
    },
    // 优惠券的动态校验
    couponRule() {
      const dataArray = this.configForm.coupons[0].coupons
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (this.queryCouponStock(currentObj.couponId) && Number(currentObj.count) > this.queryCouponStock(currentObj.couponId)) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  watch: {
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  mounted() {
    // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部机构方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()

    this.dataId = this.$route.query.id
    this.$nextTick(() => {
      // 获取数据
      this.getData()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部机构树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = resp
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType:'0' },
        callback: resp => {
          this.tagTreeData = resp
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    /**
     * 表单添加一行优惠券
     */
    addCoupon(index) {
      const data = {
        couponId: '',
        count: ''
      }
      this.configForm.coupons[0].coupons.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon(index) {
      this.configForm.coupons[0].coupons.splice(index, 1)
    },
    // 切换可参与用户时 取消可参与用户的树的选择
    partakeCancelTree() {
      this.$refs.treeMechanism.setCheckedKeys([])
      this.$refs.treeTag.setCheckedKeys([])
    },
    /**
     * 树的节点筛选
     */
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    /**
     * 选择机构 赋值
     */
    handleMechanismChange(data, checked, indeterminate) {
      this.partakeForm.mechanism = this.$refs.treeMechanism.getCheckedKeys()
    },
    /**
     * 选择标签 赋值
     */
    handleTagChange(data, checked, indeterminate) {
      this.partakeForm.tag = this.$refs.treeTag.getCheckedKeys()
    },
    /**
     * 提交
     */
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })

      let partakeFormBool = false
      this.$refs['partakeForm'].validate(valid => {
        partakeFormBool = valid
      })
      if (ruleFormBool && configFormBool && partakeFormBool) {
        this.submitData()
      }
    },
    submitData() {
      // 可参与用户下面的树的数据
      let userValue = ''
      if (this.partakeForm.userType === '2') {
        userValue = this.partakeForm.mechanism.join(',')
      } else if (this.partakeForm.userType === '3') {
        userValue = this.partakeForm.tag.join(',')
      }
      const data = {
        type: 8,
        id: this.dataId,
        name: this.ruleForm.activityName, // 活动名称
        start: this.ruleForm.activityTime[0], // 活动开始时间
        end: this.ruleForm.activityTime[1], // 活动结束时间
        // 活动配置
        coupons: [{
          coupons: this.configForm.coupons[0].coupons
        }],
        userType: this.partakeForm.userType,
        userValue: userValue// 可参与用户类型下面的树的数据
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 页面数据转换方法
    getData() {
      this.$store.dispatch('form/handle', {
        url: '/activity/get',
        data: { id: this.dataId },
        method: 'get',
        callback: (record) => {
          this.ruleForm = {
            activityName: record.name, // 活动名称
            activityTime: [record.start, record.end], // 活动时间
            activityExplain: record.description // 活动说明
          }
          this.configForm = {
            coupons: record.coupons
          }
          this.partakeForm = {
            userType: record.userType, // 可参与用户的单选字段
            mechanism: record.userType === '2' ? record.userValue.split(',') : [], // 选择企业
            tag: record.userType === '3' ? record.userValue.split(',') : [] // 选择标签
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.el-upload{
    width: 100%;
  }
  .imgborder {
    display: inline-block;
    width: 100%;
    height: 180px;
    text-align: center;
    line-height: 180px;
    border: 1px dashed #409eff;
    border-radius: 5px;
    i {
      font-size: 28px;
      color: #409eff;
    }
  }
  .avatar {
    max-height: 200px;
    width: auto;
  }
  .d-flex{
    display: flex;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/scanModify.vue